import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { IonicStorageModule } from '@ionic/storage-angular';
import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './http-interceptors';
import { ReactiveFormsModule } from '@angular/forms';
import { FooterModule } from './components/footer/footer.module';
import { provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, IonicModule.forRoot({ swipeBackEnabled: false }), AppRoutingModule, IonicStorageModule.forRoot(), HttpClientModule, ReactiveFormsModule, FooterModule],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy, }, httpInterceptorProviders, provideNgxMask()],
  bootstrap: [AppComponent]
})
export class AppModule {}
